import {mapState} from "vuex";

export const TableMixin = {
  data() {
    return {
      loading: true,
      errored: false,
      tableData: [],
      querySearch: '',
      dateFilter: [],
      pagination: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
      },
    }
  },
  methods: {
    refreshTabla() {
      this.$log.debug('refreshTabla')
      if (!this.loading) {
        this.querySearch = ''
        this.dateFilter = []
        this.tableData = []
        this.pagination.currentPage = 1
        const pagingQuery = this.getPagingQuery()
        this.$log.debug(pagingQuery)
        this.getList(pagingQuery)
      }
    },
    exportToFile() {
      this.$log.debug('onExportToFile')
      this.$emit('on-export-to-file', this.querySearch, this.dateFilter)
    },
    searchQueryEnter(value) {
      this.$log.debug('searchQueryChange', value)
      this.querySearch = value
      this.pagination.currentPage = 1
      const pagingQuery = this.getPagingQuery()
      this.getList(pagingQuery)
    },
    querySearchChange(value) {
      this.$log.debug('querySearchChange', value)
      this.querySearch = value
    },
    searchDateFilter(value) {
      this.$log.debug('searchDateFilter', value)
      this.dateFilter = value !== null ? value : []
      this.pagination.currentPage = 1
      const pagingQuery = this.getPagingQuery()
      this.getList(pagingQuery)
    },
    btnViewTitle(id) {
      return `Ver Solicitud n° ${id}`
    },
    handleSizeChange(value) {
      this.$log.debug('handleSizeChange', value)
      this.pagination.pageSize = value
      this.pagination.currentPage = 1
      const pagingQuery = this.getPagingQuery(value)
      this.getList(pagingQuery)
    },
    getPagingQuery(
      pageSize = this.pagination.pageSize,
      currentPage = this.pagination.currentPage,
      search = this.querySearch,
      dateRange = this.dateFilter) {
      this.$log.debug('getPagingQuery', pageSize, currentPage, search, this.querySearch, dateRange)
      return {
        currentPage: currentPage,
        pageSize: pageSize,
        search: search,
        dateRange: dateRange !== null ? dateRange : []
      }
    },
    handleSelectionChange(row) {
      this.$log.debug('handleSelectionChange', row)
      this.listSelection = row
      this.isSelect = row.length > 0
    },
    loadPageData(page) {
      this.$log.debug('loadPageData', this.pagination.currentPage, page)

      let pagingQuery = this.getPagingQuery()
      this.$log.debug('pagingQuery', pagingQuery)
      pagingQuery.currentPage = page
      pagingQuery.pageSize = this.pagination.pageSize

      this.getList(pagingQuery)
    },
  },
  computed: {
    ...mapState({
      parametro: state => state.parametro
    }),
    isEmptyTableData() {
      this.$log.debug('isEmptyTableData ', this.tableData.length === 0)
      return this.tableData.length === 0
    }
  },
}
